import EmptyView from 'components/EmptyView';
import React from 'react';

export default function DiscussionsView() {
  return <EmptyView />;
}
